import { NotificationLikeIcon } from '../NotificationIcons'
import NotificationDisplay from '../NotificationDisplay'

const LikeDisplayByUser = ({ user, posts, openPosts }) => {

  const handleClick = () => {
    // NOTE: remove_background turns the entire background black so we don't
    //       see the underlying screen bleed through the backnavigations
    openPosts({ remove_background: true }, { state: { posts, action: 'like', user, }})
  }

  return (
    <NotificationDisplay
      Icon={NotificationLikeIcon}
      users={[user]}
      title={<span>{user?.displayName} liked {posts.length} of your posts</span>}
      body={posts[0]?.body}
      clickCallback={handleClick}
      showAll
    />
  )
}

export default LikeDisplayByUser
